export var FORMAT_HEADING_1_MENU_ITEM = {
  key: 'block-menu-format-heading-1'
};
export var FORMAT_HEADING_2_MENU_ITEM = {
  key: 'block-menu-format-heading-2'
};
export var FORMAT_HEADING_3_MENU_ITEM = {
  key: 'block-menu-format-heading-3'
};
export var FORMAT_HEADING_4_MENU_ITEM = {
  key: 'block-menu-format-heading-4'
};
export var FORMAT_HEADING_5_MENU_ITEM = {
  key: 'block-menu-format-heading-5'
};
export var FORMAT_HEADING_6_MENU_ITEM = {
  key: 'block-menu-format-heading-6'
};
export var FORMAT_PARAGRAPH_MENU_ITEM = {
  key: 'block-menu-format-paragraph'
};
export var FORMAT_QUOTE_MENU_ITEM = {
  key: 'block-menu-format-quote'
};
export var FORMAT_EXPAND_MENU_ITEM = {
  key: 'block-menu-format-expand'
};
export var FORMAT_LAYOUT_MENU_ITEM = {
  key: 'block-menu-format-layout'
};
export var FORMAT_PANEL_MENU_ITEM = {
  key: 'block-menu-format-panel'
};
export var FORMAT_CODE_BLOCK_MENU_ITEM = {
  key: 'block-menu-format-code-block'
};
export var FORMAT_BULLETED_LIST_MENU_ITEM = {
  key: 'block-menu-format-bulleted-list'
};
export var FORMAT_NUMBERED_LIST_MENU_ITEM = {
  key: 'block-menu-format-numbered-list'
};
export var FORMAT_TASK_LIST_MENU_ITEM = {
  key: 'block-menu-format-task-list'
};
export var NESTED_FORMAT_MENU = {
  key: 'nested-menu-format'
};
export var PRIMARY_MENU_SECTION = {
  key: 'block-menu-section-primary'
};
export var NESTED_FORMAT_MENU_SECTION = {
  key: 'nested-menu-format-section-primary'
};
export var COPY_MENU_SECTION = {
  key: 'block-menu-section-copy'
};
export var DELETE_MENU_SECTION = {
  key: 'block-menu-section-delete'
};
export var MOVE_UP_DOWN_MENU_SECTION = {
  key: 'block-menu-section-move-up-down'
};
export var FORMAT_MENU_ITEM = {
  key: 'nested-menu-format-section-primary'
};
export var COPY_BLOCK_MENU_ITEM = {
  key: 'block-menu-copy-block'
};
export var COPY_LINK_MENU_ITEM = {
  key: 'block-menu-item-copy-link'
};
export var MOVE_UP_MENU_ITEM = {
  key: 'block-menu-item-move-up'
};
export var MOVE_DOWN_MENU_ITEM = {
  key: 'block-menu-item-move-down'
};
export var DELETE_MENU_ITEM = {
  key: 'block-menu-item-delete'
};